<template>
  <div class="referral-modal">
    <div class="referral-modal__content">
      <h2 class="referral-modal__title">Реферальная программа</h2>
      <p class="referral-modal__content-text">
        Пригласите друга по своей реферальной ссылке:<br />
        <span v-if="!state.isLoading" class="referral-modal__content-condition">
          ему — {{ state.referralData?.free_days_for_referral }} дней бесплатно,
          вам — {{ state.referralData?.referral_percent }}% с их платежей!
        </span>
        <span v-else>Загрузка условий...</span>
      </p>
      <div class="referral-modal__copy-block">
        <CopyLink v-if="state.referralData?.referral_link">{{
          state.referralData.referral_link
        }}</CopyLink>
        <div v-else>Загрузка ссылки...</div>
      </div>
      <div class="referral-modal__info">
        <span class="referral-modal__info-friends"
          >Приглашенных друзей:
          {{ state.referralData?.referral_count ?? "..." }}</span
        >
        <span class="referral-modal__info-friends"
          >Подписки друзей на
          {{ state.referralData?.total_spent ?? "..." }} руб.</span
        >
      </div>
    </div>

    <div class="referral-modal__footer">
      <BaseButton
        class="referral-modal__wallet-info"
        text="Вы заработали"
        styles="primary-gradient"
        :subtitile="earnedSubtitle"
        subtitle-style="medium"
        vibration="success"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, reactive, computed } from "vue";
import BaseButton from "../Base/BaseButton.vue";
import CopyLink from "../Shared/CopyLink/CopyLink.vue";
import {
  ReferralRepository,
  type ReferralResponse,
} from "@/shared/repositories/ReferralRepository";
import { SentryService } from "@/shared/lib/sentry/sentryService";

const state = reactive<{
  isLoading: boolean;
  referralData: ReferralResponse | null;
}>({
  isLoading: false,
  referralData: null,
});

const earnedSubtitle = computed(() => {
  if (state.isLoading) return "";
  return `${state.referralData?.total_earned ?? 0} руб.`;
});

onMounted(async () => {
  // Отправляем отчет об открытии модалки
  SentryService.trackModalOpen("Реферальная программа");

  try {
    state.isLoading = true;
    const { data } = await ReferralRepository.getRefSystem();
    state.referralData = data;

    // Отправляем отчет об успешной загрузке данных
    SentryService.trackUserAction("Загружены данные реферальной программы", {
      referral_count: data.referral_count || 0,
      total_earned: data.total_earned || 0,
      total_spent: data.total_spent || 0,
    });
  } catch (error) {
    console.error("Ошибка при загрузке данных реферальной системы:", error);
    // Отправляем ошибку в Sentry
    SentryService.trackError(
      error as Error,
      {
        action: "load_referral_data",
      },
      "Загрузка данных реферальной программы",
    );
  } finally {
    state.isLoading = false;
  }
});
</script>

<style lang="scss">
.referral-modal {
  display: flex;
  flex-direction: column;
  text-align: center;
  color: $neutral-100;

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 20px;
  }

  &__footer {
    margin-top: 24px;
    border-top: 1px solid $secondary-200;
    padding-top: 16px;
  }

  &__title {
    @include h1;
    color: $neutral-100;
  }

  &__content-text {
    margin-top: 12px;
    @include h1;
    font-size: 11px;
    color: $neutral-40;

    &-condition {
      color: $neutral-100;
    }
  }

  &__info {
    margin-top: 8px;
    gap: 4px;
    display: flex;
    flex-direction: column;
    text-align: start;
    color: $neutral-40;
  }

  &__copy-block {
    margin-top: 28px;
  }

  &__wallet-info {
    cursor: default;
    > button {
      cursor: default;
      padding: 15px 20px 15px 20px;
      // &:hover {
      //     cursor: default;
      //     background-color: primary-gradient;
      // }
    }
  }
}
</style>
